import { useState, useEffect } from "react";
import "./Comments.css";
import CommentsList from "./CommentsList/CommentsList";
import SelectedComment from "./SelectedComment/SelectedComment";
import { patchCommentData, deleteCommentData, getCommentsData } from "../../controllers/CommentsController";
import { Divider, Paper, Typography, CircularProgress } from "@mui/material";
import SearchBar from "../Shared/SearchBar/SearchBar";

const FilterOptions = {
    status: { type: "select", name: "Statut", possibleValues: ["Lu", "Non lu"], description: "Sélectionnez un statut pour filtrer les commentaires." },
    tags: { type: "select", name: "Tags", possibleValues: ["Bogue", "Question", "Avis"], description: "Sélectionnez un tag pour filtrer les commentaires." },
};

function Comments() {
    const [currentSearchValue, setCurrentSearchValue] = useState("");
    const [currentFilters, setCurrentFilters] = useState([]);
    const [selectedComment, setSelectedComment] = useState(null);
    const [comments, setComments] = useState([]);
    const [allComments, setAllComments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        getCommentsData()
            .then((data) => {
                setIsLoading(false);
                setComments(data);
                setAllComments(data);
            })
            .catch((error) => {
                setIsLoading(false);
                setComments([]);
                setAllComments([]);
            });
    }, []);

    const handleSelectedComment = (comment) => {
        patchCommentData(comment.id)
            .then((data) => {
                updateComment(comment.id, data);
            })
            .catch((error) => {
                console.error("Error updating comment:", error);
            });
        setSelectedComment(comment);
    };

    const updateComment = (id, data) => {
        setComments(comments.map(comment => comment.id === id ? data : comment));
        setAllComments(allComments.map(comment => comment.id === id ? data : comment));
    };

    const deleteComment = (id) => {
        deleteCommentData(id)
            .then(() => {
                setComments(comments.filter(comment => comment.id !== id));
                setAllComments(allComments.filter(comment => comment.id !== id));
                setSelectedComment(null);
            })
            .catch((error) => {
                console.error("Error deleting comment:", error);
            });
    }

    const searchComments = (searchText, commentsToUse) => {
        let commentsToFilter = commentsToUse ? commentsToUse : allComments;

        if (currentFilters.length > 0 && currentSearchValue !== searchText) {
            applyFilters(currentFilters, commentsToFilter);
        }

        setCurrentSearchValue(searchText);

        const filteredComments = commentsToFilter.filter(comment =>
            (comment.subject && comment.subject.includes(searchText)) ||
            comment.content.includes(searchText)
        );

        if (filteredComments.find(comment => comment.id === selectedComment?.id) === undefined) {
            setSelectedComment(null);
        }

        setComments(filteredComments);
    }

    const applyFilters = (filters, commentsToUse) => {
        let commentsToFilter = commentsToUse ? commentsToUse : allComments;

        setCurrentFilters(filters);
        if (currentSearchValue !== "" && currentFilters !== filters) {
            searchComments(currentSearchValue, commentsToFilter);
        }

        let filteredComments = commentsToFilter;
        filters.forEach(filter => {
            if (filter.name === "Statut") {
                if (filter.value[0] === "Lu") {
                    filteredComments = filteredComments.filter(comment => comment.is_viewed);
                } else if (filter.value[0] === "Non lu") {
                    filteredComments = filteredComments.filter(comment => !comment.is_viewed);
                }
            }
            if (filter.name === "Tags") {
                filteredComments = filteredComments.filter(comment =>
                    filter.value.some(tag => comment.tags && comment.tags.includes(tag))
                );
            }
        });

        if (filteredComments.length || filteredComments.find(comment => comment.id === selectedComment?.id) === undefined) {
            setSelectedComment(null);
        }

        setComments(filteredComments);
    }

    if (isLoading) {
        return <CircularProgress />;
    }

    return (
        <div>
            <h1 className="page-title">Commentaires</h1>
            <SearchBar search={searchComments} applyFilters={applyFilters} filterOptions={FilterOptions} />
            <Paper className="comments-container" elevation={3}>
                {comments.length > 0 ?
                    <>
                        <div className="Comments_list">
                            <CommentsList comments={comments} onSelectComment={handleSelectedComment} />
                        </div>
                        <Divider orientation="vertical" flexItem />
                        <div className="selected-comment-container">
                            {selectedComment &&
                                <SelectedComment comment={selectedComment} deleteComment={deleteComment} />
                            }
                            {!selectedComment && comments.length !== 0 &&
                                <Typography margin="1rem" variant="h6">Sélectionnez un commentaire pour le voir ici.</Typography>
                            }
                        </div>
                    </> :
                    <Typography variant="h6">Aucun commentaire trouvé.</Typography>
                }
            </Paper>
        </div>
    );
}

export default Comments;
